
























import { mixins } from 'vue-class-component'
import { Component, Prop, Watch } from 'vue-property-decorator'
import AppTextSearch from '@/components/AppTextSearch.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppSelector from '@/components/AppSelector.vue'
import AppDatePicker from '@/components/AppDatePicker.vue'
import SearchPolicy from '@/mixins/search-queries/search-policy'
import { quoteStatusValues, quoteTypeValues } from '@/modules/Quote/helpers/quote'
import { IQuoteInfoInput } from '@/modules/Quote/interfaces/quote-form'

@Component({
  components: {
    AppTextSearch,
    AppTextField,
    AppSelector,
    AppDatePicker
  }
})
export default class QuoteFormInfo extends mixins(SearchPolicy) {
  @Prop({ type: Object as () => IQuoteInfoInput }) value!: IQuoteInfoInput

  statusOptions = quoteStatusValues
  typeOptions = quoteTypeValues

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
